import request from '@/utils/request'

/**
 * 记录视频访问（学生进入视频时调用）
 */
export function logVideoVisit(data) {
  return request({
    url: '/amc/video-visit-log/enter',
    method: 'post',
    data
  })
}

/**
 * 更新视频退出信息（学生退出视频时调用）
 */
export function updateVideoVisitExit(data) {
  return request({
    url: '/amc/video-visit-log/exit',
    method: 'post',
    data
  })
}

/**
 * 获取学生课程视频访问记录
 */
export function getVideoVisitLogs(studentId, courseId) {
  return request({
    url: '/amc/video-visit-log/list',
    method: 'get',
    params: { studentId, courseId }
  })
}

/**
 * 获取学生小节视频访问记录
 */
export function getVideoVisitLogsBySection(studentId, sectionId) {
  return request({
    url: '/amc/video-visit-log/list-by-section',
    method: 'get',
    params: { studentId, sectionId }
  })
}
